import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Caught error:", error?.message || error);
    console.error("[ErrorBoundary] Component stack:", info?.componentStack);
    console.error("[ErrorBoundary] Full error object:", error);
    this.setState({ info });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: "monospace", background: "#1a0000", color: "#ff6666", minHeight: "100dvh" }}>
          <h2 style={{ color: "#ff4444", marginBottom: 16 }}>⚠ React Error — check DevTools console for stack trace</h2>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 13 }}>
            {this.state.error?.message || String(this.state.error)}
          </pre>
          {this.state.info?.componentStack && (
            <pre style={{ marginTop: 16, fontSize: 11, color: "#ff9999", whiteSpace: "pre-wrap" }}>
              {this.state.info.componentStack}
            </pre>
          )}
          <button
            style={{ marginTop: 24, padding: "8px 20px", background: "#ff4444", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontFamily: "monospace" }}
            onClick={() => { this.setState({ error: null, info: null }); window.location.reload(); }}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
